// readmore
(function() {

	$('.readmore').readmore({
		collapsedHeight: 450,
		embedCSS: false,
		blockCSS: false,
		moreLink: '<div class="readmore__button"><a href="#"><span class="dotted">Развернуть полное описание</span></a></div>',
		lessLink: '<div class="readmore__button"><a href="#"><span class="dotted">Свернуть описание</span></a></div>',
	});

})();



// WEBPACK FOOTER //
// G:/RABOTA/satpharma/dev/source/modules/readmore/readmore.js